import { of, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { RecordingService } from '../services';
import { State } from '../services/work.state';

export const pcsCancel = () =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.postCallSurveyCancel !== undefined) {
        const newState = {
          ...state,
          ...{
            postCallSurveyCancel: state.system?.postCallSurveyCancel,
            system: {
              ...state.system,
              ...{
                postCallSurveyCancel: undefined,
              },
            },
          },
        };
        return of([newState, currentState] as [Partial<State>, State]);
      }

      return of([state, currentState] as [Partial<State>, State]);
    })
  );
